export default () => {
  const triggers = document.querySelectorAll('.js-trigger-click');
  if (triggers.length < 1) return;

  [...triggers].forEach(trigger => {
    const child = trigger.querySelector('.js-target-click');

    trigger.addEventListener('click', e => {
      if (e.target.type=='checkbox') child.classList.toggle('active');
    });
  });
};


// WEBPACK FOOTER //
// ./src/js/modules/TargetClick.js